import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import StripeInput from './StripeInput';

// Cache the Stripe elements
let stripeElements = null;

const loadStripeElements = async () => {
  if (!stripeElements) {
    const { CardCvcElement, CardExpiryElement, CardNumberElement } =
      await import('@stripe/react-stripe-js');
    stripeElements = { CardCvcElement, CardExpiryElement, CardNumberElement };
  }
  return stripeElements;
};

export const StripeTextField = (props) => {
  const {
    helperText,
    InputLabelProps,
    InputProps = {},
    inputProps,
    error,
    labelErrorMessage,
    stripeElement: StripeElementType,
    ...other
  } = props;

  const [StripeElement, setStripeElement] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadElement = async () => {
      try {
        const elements = await loadStripeElements();
        setStripeElement(() => elements[StripeElementType]);
      } catch (error) {
        console.error('Failed to load Stripe element:', error);
      } finally {
        setIsLoading(false);
      }
    };

    if (StripeElementType) {
      loadElement();
    }
  }, [StripeElementType]);

  if (isLoading || !StripeElement) {
    return (
      <TextField
        fullWidth
        size="small"
        InputLabelProps={{
          ...InputLabelProps,
          shrink: true,
        }}
        disabled
        placeholder="Loading payment field..."
        {...other}
      />
    );
  }

  return (
    <TextField
      fullWidth
      size="small"
      InputLabelProps={{
        ...InputLabelProps,
        shrink: true,
      }}
      error={error}
      InputProps={{
        ...InputProps,
        inputProps: {
          ...inputProps,
          ...InputProps.inputProps,
          component: StripeElement,
        },
        inputComponent: StripeInput,
      }}
      helperText={error ? labelErrorMessage : helperText}
      {...other}
    />
  );
};

export const StripeTextFieldNumber = (props) => (
  <StripeTextField {...props} stripeElement="CardNumberElement" />
);

export const StripeTextFieldExpiry = (props) => (
  <StripeTextField {...props} stripeElement="CardExpiryElement" />
);

export const StripeTextFieldCVC = (props) => (
  <StripeTextField {...props} stripeElement="CardCvcElement" />
);
